import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PermissionDeniedComponent} from './permission-denied/permission-denied.component';
import {CustomerComponent} from './customer/customer.component';
import {ContractComponent} from './contract/contract.component';
import {AppAuthGuard} from "./auth/app.auth.guard";

const routes: Routes = [
  {
    path: '',
    component: CustomerComponent,
    canActivate: [AppAuthGuard],
    children: [
      {
        path: 'permission-denied',
        component: PermissionDeniedComponent
      },
      {
        path: 'customer',
        component: CustomerComponent
      }
    ]
  },
  {
    path: 'contract',
    component: ContractComponent,
    canActivate: [AppAuthGuard],
    children: [
      {
        path: 'permission-denied',
        component: PermissionDeniedComponent
      }
    ]
  },
  {
    path: 'translation',
    loadChildren: () => import('./translation/translation.module').then(m => m.TranslationModule),
    canActivate: [AppAuthGuard],
  },
  {
    path: 'system',
    loadChildren: () => import('./system/system.module').then(m => m.SystemModule),
    canActivate: [AppAuthGuard],
  },
  {
    path: 'app-storage',
    loadChildren: () => import('./app-storage/app-storage.module').then(m => m.AppStorageModule),
    canActivate: [AppAuthGuard],
  }
];

@NgModule({
            imports: [RouterModule.forRoot(routes)],
            exports: [RouterModule]
          })
export class AppRoutingModule {
}
